import mod from "-!./collaborations.js?vue&type=script&lang=js&"; export default mod; export * from "-!./collaborations.js?vue&type=script&lang=js&"